var _rect, _path, _rect2, _rect3, _rect4, _rect5, _line, _line2, _line3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostidentStepOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 43,
    viewBox: "0 0 100 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 41,
    height: 35,
    rx: 3,
    stroke: "#4EA699",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31H52V33C52 34.6569 50.6569 36 49 36H4C2.34315 36 1 34.6569 1 33V31Z",
    fill: "white",
    stroke: "#4EA699",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 8,
    width: 28,
    height: 7,
    fill: "white",
    stroke: "#4EA699",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 1,
    width: 16,
    height: 14,
    fill: "white",
    stroke: "#4EA699",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 15,
    width: 41,
    height: 19,
    rx: 3,
    fill: "white",
    stroke: "#4EA699",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 29,
    width: 20,
    height: 13,
    fill: "white",
    stroke: "#4EA699",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 38.5,
    x2: 84,
    y2: 38.5,
    stroke: "#4EA699"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 35.5,
    x2: 84,
    y2: 35.5,
    stroke: "#4EA699"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 32.5,
    x2: 84,
    y2: 32.5,
    stroke: "#4EA699"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 19,
    r: 1,
    fill: "#4EA699"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 19,
    r: 1,
    fill: "#4EA699"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 19,
    r: 1,
    fill: "#4EA699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostidentStepOne);
export default __webpack_public_path__ + "static/media/postident-step-one.13a4ef8c736e3c81b3ada6a339f805e7.svg";
export { ForwardRef as ReactComponent };